import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { BillingInterval, SignupChargeDetails } from "features/types";
import { CmsPlan } from "lib/sanity.types";

type SignupCharges = Array<{
  planPackageId: number;
  billingInterval: BillingInterval;
  signupCharge: SignupChargeDetails;
}>;

interface ShopPagePhaseTwoSlice {
  step: number;
  group: string;
  selectedCmsPlan: CmsPlan | null;
  signupCharges: SignupCharges;
  quantity: number;
}
const initialState: ShopPagePhaseTwoSlice = {
  step: 1,
  group: "",
  selectedCmsPlan: null,
  signupCharges: [],
  quantity: 1,
};

export const shopPagePhaseTwoSlice = createSlice({
  name: "shopPagePhaseTwo",
  initialState,
  reducers: {
    setStep: (state, action: PayloadAction<number>) => {
      state.step = action.payload;
    },
    setGroup: (state, action: PayloadAction<string>) => {
      state.group = action.payload;
    },
    setSelectedCmsPlan: (state, action: PayloadAction<CmsPlan>) => {
      state.selectedCmsPlan = action.payload;
    },
    setSignupCharges: (state, action: PayloadAction<SignupCharges>) => {
      state.signupCharges = action.payload;
    },
    setQuantity: (state, action: PayloadAction<number>) => {
      state.quantity = action.payload;
    },
    resetShopPagePhaseTwo: (state) => {
      state.step = 1;
      state.group = "";
      state.selectedCmsPlan = null;
      state.signupCharges = [];
      state.quantity = 1;
    },
  },
});

export const {
  setGroup,
  setSelectedCmsPlan,
  setStep,
  setSignupCharges,
  setQuantity,
  resetShopPagePhaseTwo,
} = shopPagePhaseTwoSlice.actions;
export default shopPagePhaseTwoSlice.reducer;
